import { PlayObject } from '../model/PlayObject'
import * as WhichObject from '../model/constants/WhichObject'

export class AudioPlayerUtils {
  static getPreRollAds(ads = []) {
    return ads.filter((data) => data.ad.type === 'preroll')
  }

  static getMidRollAds(ads = []) {
    return ads.filter((data) => data.ad.type === 'midroll')
  }

  /**
   * Creates a list of playObjects so that it is easy for the audio player to navigate through the list.
   *
   * @param episodes
   * @param preRollAds
   * @param midRollAds
   * @returns {Array}
   */
  static getListOfPlayObjects(episodes, preRollAds, midRollAds) {
    return episodes.reverse().map((item, index) => new PlayObject(index, item, preRollAds, midRollAds))
  }

  /**
   * Returns the object from the listPlayObjects which has the same episode.id as whichObject.
   *
   * WhichObject can be a UUID or a string such as NEXT or PREVIOUS.
   *
   * @param whichObject
   * @param playObjects
   */
  static getPlayObjectFromListById(whichObject, playObjects) {
    return playObjects.find((playObject) => whichObject === playObject.episode.id)
  }

  static getPlayObjectFromListByIndexId(which, currentPlayObject, playObjects) {
    let indexOfObjectToGet = currentPlayObject.episodeIndex
    if (which === WhichObject.NEXT) {
      if (indexOfObjectToGet === playObjects.length - 1) {
        indexOfObjectToGet = 0
      } else {
        indexOfObjectToGet++
      }
    } else if (which === WhichObject.PREVIOUS) {
      if (indexOfObjectToGet === 0) {
        indexOfObjectToGet = playObjects.length - 1
      } else {
        indexOfObjectToGet--
      }
    }
    return playObjects.find((playObject) => {
      return indexOfObjectToGet === playObject.episodeIndex
    })
  }

  /**
   * Removes an ad from the playlist because the user should not listen to an ad again after
   * having listened to it once.
   * @param currentPlayObject
   */
  static removeAdFromMidrollList(currentPlayObject) {
    currentPlayObject.midRollads.forEach((adwrapper, index) => {
      if (adwrapper.timestamp === currentPlayObject.currentMidroll) {
        currentPlayObject.midRollads.splice(index, 1)
      }
    })
  }

  static playAudio(player, url, time) {
    player.src = url
    player.currentTime = time
    player.play()
  }

  static seekTo(player, time) {
    player.currentTime = time
  }

  static isMidRollPoint(currentTime, ad) {
    let lowerBound = currentTime - 1.0
    let upperBound = currentTime + 1.0
    return lowerBound < ad.timestamp && ad.timestamp < upperBound
  }

  /**
   * To be able to play an episode or ad on the first click of any episode this fake start must be made.
   * Otherwise, the audio stream will be stopped because the audio player can not be started for the first time
   * with javascript.
   */
  static fakeStartEpisodeIfPlayerHasNoSrc() {
    var player = document.getElementById('audioplayer')
    if (!player.src) {
      player.src = ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/AudioPlayer/utils/AudioPlayerUtils.js